import Vue from 'vue';
import App from './App.vue';
import i18n from './locale';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';
import { dateHandler } from './utils';
import { loadRuntimeConfig, get } from './utils/runtime-config';

import BaseChart from '@/components/chart/BaseChart.vue';
import BaseDetailItem from '@/components/BaseDetailItem.vue';
import BaseDetailLink from '@/components/BaseDetailLink.vue';
import BaseDetailUrl from '@/components/BaseDetailUrl.vue';
import BaseFormNumberField from '@/components/BaseFormNumberField.vue';
import BaseFormTextField from '@/components/BaseFormTextField.vue';
import BaseLoadingCircular from '@/components/BaseLoadingCircular.vue';
import BaseLoadingLinear from '@/components/BaseLoadingLinear.vue';
import BaseSmallWindow from '@/components/BaseSmallWindow.vue';
import BaseTopContentCard from '@/components/BaseTopContentCard.vue';
import BaseTransactionMessage from '@/components/BaseTransactionMessage.vue';
import TheAlertNotice from '@/components/TheAlertNotice.vue';
import TheChainChooser from '@/components/TheChainChooser.vue';
import TheErrorMessage from '@/components/TheErrorMessage.vue';
import TheHeaderContent from '@/components/TheHeaderContent.vue';
import TheLatestHeight from '@/components/TheLatestHeight.vue';
import TheSearchBar from '@/components/TheSearchBar.vue';
import TheTxAssertModal from '@/components/TheTxAssertModal.vue';

Vue.component('base-chart', BaseChart);
Vue.component('base-detail-item', BaseDetailItem);
Vue.component('base-detail-link', BaseDetailLink);
Vue.component('base-detail-url', BaseDetailUrl);
Vue.component('base-form-number-field', BaseFormNumberField);
Vue.component('base-form-text-field', BaseFormTextField);
Vue.component('base-loading-circular', BaseLoadingCircular);
Vue.component('base-loading-linear', BaseLoadingLinear);
Vue.component('base-small-window', BaseSmallWindow);
Vue.component('base-top-content-card', BaseTopContentCard);
Vue.component('base-transaction-message', BaseTransactionMessage);
Vue.component('the-alert-notice', TheAlertNotice);
Vue.component('the-chain-chooser', TheChainChooser);
Vue.component('the-error-message', TheErrorMessage);
Vue.component('the-header-content', TheHeaderContent);
Vue.component('the-latest-height', TheLatestHeight);
Vue.component('the-search-bar', TheSearchBar);
Vue.component('the-tx-assert-modal', TheTxAssertModal);

Vue.config.productionTip = false;

// Synchronize dayjs locale with vue-i18n locale on app startup
dateHandler.setLocale(i18n.locale);

// Load runtime configuration before mounting the app
loadRuntimeConfig()
  .then(() => {
    // Apply theme colors from runtime config
    const lightPrimary = get('theme.colors.light.primary');
    const lightBackground = get('theme.colors.light.background');
    const lightBackgroundFooter = get('theme.colors.light.backgroundFooter');
    const darkPrimary = get('theme.colors.dark.primary');
    const darkSecondary = get('theme.colors.dark.secondary');

    if (lightPrimary) {
      vuetify.framework.theme.themes.light.primary = lightPrimary;
    }
    if (lightBackground) {
      vuetify.framework.theme.themes.light.background = lightBackground;
    }
    if (lightBackgroundFooter) {
      vuetify.framework.theme.themes.light.backgroundFooter = lightBackgroundFooter;
    }
    if (darkPrimary) {
      vuetify.framework.theme.themes.dark.primary = darkPrimary;
    }
    if (darkSecondary) {
      vuetify.framework.theme.themes.dark.secondary = darkSecondary;
    }

    // Update favicon from runtime config
    const favicon = get('theme.favicon', '/favicon-default.ico');
    const faviconLink = document.querySelector("link[rel='icon']");
    if (faviconLink) {
      faviconLink.href = favicon;
    }

    // Update page title from runtime config
    const mainTitle = get('chain.mainTitle');
    if (mainTitle) {
      document.title = mainTitle;
    }

    // Mount the app after configuration is loaded
    new Vue({
      i18n,
      router,
      store,
      vuetify,
      render: (h) => h(App),
    }).$mount('#app');
  })
  .catch((error) => {
    console.error('[Main] Failed to load runtime configuration:', error);
    // Mount the app anyway with fallback values
    new Vue({
      i18n,
      router,
      store,
      vuetify,
      render: (h) => h(App),
    }).$mount('#app');
  });
